import React from 'react'

import ConditionalWrapper from '~/components/conditional-wrapper'

import {
  StepsWrapper,
  Content,
  IconWrapper,
  Subtitle,
  StepWrapper,
} from './step-counter.styles'
import Button from '../button'

import type { Props, StepProps, StepContentProps } from './step-counter.types'

export const StepContent = ({ step, isCurrentStep }: StepContentProps) => {
  return (
    <Content>
      <IconWrapper $isCurrentStep={isCurrentStep}>{step.icon}</IconWrapper>
      <Subtitle>{step.subtitle}</Subtitle>
    </Content>
  )
}

const CheckoutStep = ({
  currentStep,
  step,
  index,
  lastStepIndex,
}: StepProps) => {
  const isCurrentStep = currentStep === step.stepNum
  const isLastStep = index === lastStepIndex
  return (
    <StepWrapper $isLastStep={isLastStep}>
      <ConditionalWrapper
        condition={
          step.to != null &&
          currentStep != undefined &&
          currentStep > step.stepNum
        }
        wrapper={(children) => (
          <Button to={step.to} type="unstyled">
            {children}
          </Button>
        )}
      >
        <StepContent step={step} isCurrentStep={isCurrentStep} />
      </ConditionalWrapper>
    </StepWrapper>
  )
}

export default function StepCounter({ steps, currentStep }: Props) {
  return (
    <StepsWrapper data-testid="step-counter">
      {steps.map((step, idx) => (
        <CheckoutStep
          key={step.subtitle}
          currentStep={currentStep}
          step={step}
          index={idx}
          lastStepIndex={steps.length - 1}
        />
      ))}
    </StepsWrapper>
  )
}
